import { render, staticRenderFns } from "./efresult.vue?vue&type=template&id=2979cce8&lang=pug&"
import script from "./efresult.vue?vue&type=script&lang=js&"
export * from "./efresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports